export default __webpack_public_path__ + "static/media/canada.7cc54035.webp";